import React from "react";
import { Link } from "react-router-dom";

export default function AdminVideos() {
  return (
    <main className="min-h-screen bg-black p-6 text-white md:p-10">
      <section className="mx-auto max-w-5xl rounded-lg border border-white/10 bg-zinc-950 p-6 md:p-8">
        <p className="mb-3 text-sm font-bold uppercase tracking-[0.25em] text-red-500">
          Admin Videos
        </p>
        <h1 className="text-4xl font-black uppercase md:text-6xl">YouTube</h1>
        <p className="mt-5 max-w-2xl text-gray-400">
          L'ajout et la suppression des videos YouTube sont deja disponibles dans le
          dashboard principal. Cette entree sert de raccourci clair tant qu'un module
          dedie n'est pas necessaire.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/admin" className="rounded-full bg-white px-5 py-2 text-sm font-bold uppercase tracking-wide text-black">
            Gerer les videos
          </Link>
          <Link to="/videos" className="rounded-full border border-white/20 px-5 py-2 text-sm font-bold uppercase tracking-wide">
            Voir la page
          </Link>
        </div>
      </section>
    </main>
  );
}
